import React from "react";
import { render } from "react-dom";
import assertContainerElement from "Utils/assertContainerElement";
import WorkplaceSearchForm from "./Components/WorkplaceSearchForm";
import ResourcesSection from "./Components/ResourcesSection";
import "Styles/Pages/hp2.scss";
import { BlockedUserModal } from "Pages/Components/BlockedUserModal";
import initHowItWorksVideo from "./Components/HowItWorks";
import initHappyPeopleSection from "../Components/Sections/HappyPeopleSection";

document.addEventListener("DOMContentLoaded", () => {
   document.getElementById("hp-hero-animation")?.classList.add("hp2-hero-animation--animate");
}, { once: true });

// ---- search input ----
const searchFormRoot = document.getElementById("hp2-hero-search");
assertContainerElement(searchFormRoot);
render(<WorkplaceSearchForm />, searchFormRoot);

initHappyPeopleSection();

// ---- resources ----
const root = document.getElementById("hp2-section-resources");
assertContainerElement(root);

render(<ResourcesSection />, root);

// ---- block user ----

const blockedUserModalRoot = document.getElementById("blocked-user-modal");
assertContainerElement(blockedUserModalRoot);
const blockedUserTypeString = blockedUserModalRoot.dataset["type"];
const blockedUserType = blockedUserTypeString == LSCommon.Models.BlockedUserMessageType.Blocked
   ? LSCommon.Models.BlockedUserMessageType.Blocked
   : blockedUserTypeString == LSCommon.Models.BlockedUserMessageType.Locked
      ? LSCommon.Models.BlockedUserMessageType.Locked
      : LSCommon.Models.BlockedUserMessageType.None;
const blockedUserModalFirstName = blockedUserModalRoot.dataset["firstName"]!;

render(<BlockedUserModal type={blockedUserType} firstName={blockedUserModalFirstName} />, blockedUserModalRoot);

// ---

setTimeout(() => { initHowItWorksVideo(); }, 500);
